import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { IntlProvider } from 'react-intl';
import { useLocale } from '../contexts/LocaleProvider';
import ProductHome from './productPage/ProductHome';
import { useLocation } from 'react-router-dom';
import { useProductGroups } from '../graphql/pimcore/modules/resourceLibrary/contexts/ProductGroupsProvider';
import LoadingOverlay from './common/LoadingOverlay';
import { useProductsContent } from '../graphql/pimcore/modules/siteContent/hooks/useProductsContent';

const ProductPage: FunctionComponent = () => {
    const { locale, messages } = useLocale();
    const location = useLocation();
    const { productGroupByDmDefinitionId, loading: productGroupLoading } = useProductGroups();
    const { loading: productContentLoading, contentTree } = useProductsContent();

    return (
        <>
            <LoadingOverlay loading={productGroupLoading || productContentLoading} />
            <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
                <Box
                    width="100%"
                    component="main"
                    sx={{
                        padding: 0,
                        flexGrow: 0,
                        p: 0, // 内边距
                        // overflowY: 'hidden'
                    }}
                >
                    <ProductHome
                        stateFromQueryRaw={location.state?.initialFilterState}
                        queryRawResults={location.state?.queryRawResults}
                        searchInput={location.state?.searchInput}
                        leftOverParam={location.state?.leftOverParam}
                        customBannerMessage={location.state?.customBannerMessage}
                        shouldClearAllProps={location.state?.shouldClearAllProps}
                        productGroupByDmDefinitionId={productGroupByDmDefinitionId}
                        contentTree={contentTree}
                    />
                </Box>
            </IntlProvider>
        </>
    );
};

export default ProductPage;
